<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-26
    	描述：商品管理-商品编辑-商品内容
    -->
  <div class="basic-setting-content pl16 pr16">
    <!--商品详情-->
    <div class="common-form">禁忌说明</div>
    <!--内容-->
    <el-form-item label="说明内容：">
      <div class="edit_container">
        <Uediter :text="form.model.tabooContent" :config="ueditor.config" ref="ue2" @contentChange="contentChangeFunc"></Uediter>
      </div>
    </el-form-item>
  </div>
</template>

<script>
import Uediter from "@/components/UE2.vue";
import draggable from "vuedraggable";
export default {
  components: {
    /*编辑器*/
    Uediter,
    draggable
  },
  data() {
    return {
      /*富文本框配置*/
      ueditor: {
        text: "",
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      is_upload: false,
      config: {
        total: 9,
        fileType: "image"
      }
    };
  },
  created() {
    console.log(this.form.model.tabooContent)
    this.ueditor.text = this.form.model.tabooContent;
  },
  inject: ["form"],
  methods: {
    /*获取富文本框内容*/
    getContent: function() {
      return this.$refs.ue2.getUEContent();
    },

    /*获取富文本内容*/
    contentChangeFunc(e) {
      this.form.model.tabooContent = e;
    },
    openUpload() {
      this.is_upload = true;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/part/Spec.vue